var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"px-0"},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"12","md":"12"}},[_c('high-charts-drill-bar',{attrs:{"id":1000,"items":_vm.items,"visibleTitle":true,"title":'GESTION POR DIA',"number":true,"name":'Dìa',"typeGraph":'line',"legend":true}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }